<template>
  <v-app>
    <v-main v-if="!loading">
      <v-container class="pa-0 ma-0" fluid style="height: 100%;">
        <div v-if="this.routerName">
          <left-nav :show="!$vuetify.breakpoint.smAndDown" />

          <bottom-nav v-if="$vuetify.breakpoint.smAndDown" />

          <header-nav ref="headerCadu" @change-image="changeImage" @change-data="changeData" />
        </div>

        <pendencia-modal
          ref="pendenciaModal"
          @close="pendencia = false"
          @reload="reloadHeader"
          @new-image="putData"
          :pendencia="pendencia"
        />

        <router-view ref="router" @loadDados="meusDados" style="height: 100%;" :style="appStyle" :key="viewKey">
        </router-view>

        <footer class="font-secundaria" v-if="$route.name === 'home'">
          <span class="primary1--text font-weight-bold"> Versão: </span> {{ versaoProjeto }}
        </footer>
      </v-container>
    </v-main>

    <overlay-loading v-model="loadingAll" />

    <error-modal v-model="showError" :errObj="errObj" :titulo="normalErr ? 'Atualização' : 'Há algo errado.'">
      <div slot="footer-buttons">
        <v-row v-if="normalErr">
          <v-col cols="auto">
            <button-cadu @click="showError = false"> NÃO </button-cadu>
          </v-col>

          <v-col cols="auto">
            <button-cadu @click="visualizar"> SIM </button-cadu>
          </v-col>
        </v-row>

        <v-row v-if="edicaoErr">
          <v-col cols="auto">
            <button-cadu outline @click="showError = false"> CANCELAR </button-cadu>
          </v-col>

          <v-col cols="auto">
            <button-cadu @click="visualizar"> CONTINUAR </button-cadu>
          </v-col>
        </v-row>
      </div>
    </error-modal>
  </v-app>
</template>

<script>
import Usuario from './services/Usuario'
import Area from './services/Area'
import Cargo from './services/Cargo'
import Unimed from '@/services/Unimed'
import axios from 'axios'
import { EventBus } from '@/services/EventBus/EventBus'

export default {
  name: 'App',
  data() {
    return {
      tokenBearer: '',
      show: false,
      pendencia: false,
      url: '',
      loading: true,
      idUnimed: -1,
      loadingToken: false,
      routes: [
        'home',
        'minhaunimed',
        'administracao',
        'pendencias',
        'novaUnimed',
        'consultarUnimed',
        'dirigentes',
        'transacaoOnline',
        'relatorios'
      ],
      showError: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      normalErr: false,
      edicaoErr: false,
      loadingAll: false,
      viewKey: 1,

      versaoProjeto: process.env.PACKAGE_VERSION
    }
  },
  beforeCreate() {
    axios.get('/assets/config.json').then((response) => {
      this.$appConfig = { config: response.data }
      this.url = response.data.API
      this.loading = false
      this.tokenBearer = localStorage.getItem('tokenBearer')
    })

    EventBus.$on('editarUnimed', () => this.editar())
    EventBus.$on('visualizarUnimed', () => this.visualizar())
  },
  beforeDestroy() {
    EventBus.$off('visualizarUnimed')
    EventBus.$off('editarUnimed')
  },
  methods: {
    async unimedCancelar() {
      const unimed = new Unimed(this.tokenBearer, this.$appConfig.config.API)

      await unimed.putCancelEdit().catch((err) => {
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        this.showError = true
        this.normalErr = false
      })
    },
    async visualizar() {
      if (this.$route.name === 'minhaunimed') {
        localStorage.setItem('optionEdit', false)
        this.viewKey += 1
        return
      }

      localStorage.setItem('optionEdit', false)
      EventBus.$emit('breadCrumbPast', 0)

      this.loadingAll = true
      this.showError = false

      if (JSON.parse(localStorage.getItem('optionEdit'))) await this.unimedCancelar()

      await this.$nextTick()

      this.$router.push({ name: 'minhaunimed', params: { idUnimed: this.idUnimed } }).catch((err) => {})
      this.loadingAll = false
    },
    async editar() {
      if (this.$route.name === 'minhaunimed') {
        localStorage.setItem('optionEdit', true)
        this.viewKey += 1
        return
      }

      localStorage.setItem('optionEdit', true)
      EventBus.$emit('breadCrumbPast', 0)

      this.loadingAll = true
      const unimed = new Unimed(this.tokenBearer, this.$appConfig.config.API)

      await unimed
        .putStartEdit(this.idUnimed)
        .then(() => {
          this.$nextTick()
          this.$router.push({ name: 'minhaunimed', params: { idUnimed: this.idUnimed } }).catch((err) => {})
        })
        .catch((err) => {
          const msg = err.response.data.message
          const status = err.response.status
          this.errObj.status = status
          this.errObj.error = msg

          if (status !== 500) {
            if (msg.includes('pendente')) this.normalErr = true
            else this.edicaoErr = true
          }

          this.showError = true
        })
        .finally(() => (this.loadingAll = false))
    },
    async meusDados() {
      this.tokenBearer = localStorage.getItem('tokenBearer')

      const usuario = new Usuario(this.tokenBearer, this.url)
      const area = new Area(this.tokenBearer, this.url)
      const cargo = new Cargo(this.tokenBearer, this.url)

      try {
        let responseUsuario = await usuario.getUser()

        this.pendencia = responseUsuario.data.isPrimeiroAcesso
        responseUsuario = responseUsuario.data
        this.idUnimed = responseUsuario.unimed.id;

        localStorage.setItem('idUnimed', this.idUnimed);

        if (this.pendencia) {
          let responseArea = await area.getAreas()
          let responseCargo = await cargo.getCargos()
          responseArea = responseArea.data
          responseCargo = responseCargo.data

          this.verifyPendencia({ responseUsuario, responseArea, responseCargo })
        } else {
          this.$refs.headerCadu.dadosMenu(responseUsuario)
        }
      } catch (err) {
        console.error(err)
        this.$router.push('/erro')
        this.$emit('hideMenu')
      }
    },
    verifyPendencia(data) {
      this.$refs.pendenciaModal.$refs.formModal.verifyPendencia(data)
    },
    async putData(image) {
      this.tokenBearer = localStorage.getItem('tokenBearer')

      this.data.append('foto', image)

      const usuario = new Usuario(this.tokenBearer)
      await usuario.putImage(this.data)
    },
    changeImage() {
      this.pendencia = true

      this.$refs.pendenciaModal._data.close = true
      this.$refs.pendenciaModal._data.step = 1
      this.$refs.pendenciaModal._data.onlyImage = true
      this.$refs.pendenciaModal._data.trocarDados = true
    },
    changeData() {
      this.pendencia = true

      this.$refs.pendenciaModal._data.close = true
      this.$refs.pendenciaModal._data.step = 0
      this.$refs.pendenciaModal._data.onlyImage = false
      this.$refs.pendenciaModal._data.trocarDados = true
    },
    async reloadHeader() {
      this.tokenBearer = localStorage.getItem('tokenBearer')
      const usuario = new Usuario(this.tokenBearer, this.url)

      await usuario.getUser().then((res) => {
        this.$refs.headerCadu.dadosMenu(res.data)
      })
    }
  },
  computed: {
    appStyle() {
      return this.routerName
        ? this.$vuetify.breakpoint.smAndDown
          ? 'padding: 60px 0; !important'
          : 'padding: 60px 0 0 0px; !important'
        : ''
    },
    routerName() {
      return this.routes.includes(this.$route.name)
    }
  }
}
</script>

<style lang="scss" scoped>
footer {
  position: absolute;
  bottom: 10px;
  right: 30px;
}
</style>
